import { css } from '@emotion/react';
import React from 'react';
import { Cell, CellBase, HeaderCell, Row, Table, TextWrap } from '../../../../styles/table';
import { ITraversalOrder } from '../../../../types/api/traversal/order';
import { color } from '../../../../styles';
import { IGetDiaperRes } from '../../../../types/api/care-settings/getDiaper';
import { OrderableSelectorCell } from './orderableDiaperSelectorCell';
import { MenuItemProps } from '../../../../components/mui/select';
import { OrderAmountCell } from './orderAmountCell';

interface Props {
  data: ITraversalOrder[];
  orderableList: IGetDiaperRes[] | undefined;
  onAmountChange: (id: number, value: number) => void;
  onDiaperNameChange: (id: number, value: MenuItemProps) => void;
  onDelete: (id: number) => void;
}

const CellHeight = css`
  height: 88px;
`;

const Separate = css`
  padding-left: 16px;
`;

const LinkText = css`
  display: flex;
  align-items: center;
  color: ${color.red};
  padding: 0 10px;
  height: 70%;

  &:hover {
    background-color: ${color.bg_gray};
  }
`;

// テーブルのセルの横幅を左から順に定義
const CellWidth = [{ flex: '3 1 380px' }, { flex: '0 0 180px' }, { flex: '0 0 90px' }];

export const DiaperOrderChangeTable = ({
  data,
  orderableList,
  onAmountChange,
  onDiaperNameChange,
  onDelete,
}: Props) => {
  const tableHeader = ['名前', '発注数', '操作'];

  const handleClickDelete = React.useCallback(
    (id: number) => () => {
      onDelete(id);
    },
    [onDelete]
  );

  const handleChangeDiaperName = React.useCallback(
    (id: number) => (value: MenuItemProps) => {
      onDiaperNameChange(id, value);
    },
    [onDiaperNameChange]
  );

  const handleChangeAmount = React.useCallback(
    (id: number) => (value: number) => {
      onAmountChange(id, value);
    },
    [onAmountChange]
  );

  return (
    <>
      <div css={Table}>
        <div css={Row}>
          {tableHeader.map((hData, i) => {
            return (
              <div css={[CellBase, HeaderCell, CellWidth[i], Separate]} key={i}>
                {hData}
              </div>
            );
          })}
        </div>
        {data.map((data, i) => {
          return (
            <div css={Row} key={data.id}>
              <div css={[CellBase, Cell, CellWidth[0], TextWrap, CellHeight, Separate]}>
                {orderableList ? (
                  <OrderableSelectorCell
                    value={data}
                    orderableList={orderableList}
                    onChange={handleChangeDiaperName(i)}
                  />
                ) : (
                  data.diaperShorten
                )}
              </div>
              <div css={[CellBase, Cell, CellWidth[1], CellHeight, Separate]}>
                <OrderAmountCell value={data.amount} onChange={handleChangeAmount(i)} />
              </div>
              <div css={[CellBase, Cell, CellWidth[2], CellHeight, Separate]}>
                <div css={LinkText} onClick={handleClickDelete(i)}>
                  削除
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
